import { getUseResource } from '../resource';
import { overviewResources } from '../builders/overviewResources';
import { IInstaller } from '../../models/Installer';
import { IProductDetails } from '../models/IProduct';
import { IAdminExpiringLicense } from '../../models/AdminOverviewResponse';
import { IOverviewMachines } from '../../models/UserOverview';
import { ICustomerOverviewResponse } from '../../models/CustomerOverview';
import { IUserExample } from '../models/IUserExample';

export interface IProductOverview {
  hasExamples: boolean;
  product: IProductDetails;
}

export interface ISummaryLatest {
  version: string | null;
  installer: IInstaller[];
}

export interface ISummaryLicenses {
  licensesInUse: number;
}

export const apiOverview = {
  useGetProductsList: getUseResource(
    overviewResources.getProductsList,
    (body): { products: IProductOverview[] } => body
  ),
  useListUserProducts: getUseResource(
    overviewResources.listUserProducts,
    (body): { products: IProductOverview[] } => body
  ),
  useGetProductExamples: getUseResource(
    overviewResources.getProductExamples,
    (body): { userExamples: IUserExample[] } => body
  ),
  useGetProductSummaryLatest: getUseResource(overviewResources.getProductSummaryLatest, (body): ISummaryLatest => body),
  useGetSummaryExpirations: getUseResource(
    overviewResources.getSummaryExpirations,
    (body): IAdminExpiringLicense[] => body
  ),
  useGetSummaryUserLicenses: getUseResource(
    overviewResources.getSummaryUserLicenses,
    (body): IOverviewMachines => body
  ),
  useGetSummaryMyLicenses: getUseResource(overviewResources.summaryMyLicenses, (body): IOverviewMachines => body),
  useGetOrganizationSummary: getUseResource(
    overviewResources.getOrganizationSummary,
    (body): ICustomerOverviewResponse => body
  ),
};
